import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+platform__services-providers-project-context
import { useProjectContext } from '@jira/platform__services-providers-project-context/src/index.tsx';

export const useIsProjectAdmin = (): boolean => {
	const isJiraAdmin = useIsAdmin();
	const projectContext = useProjectContext();
	return isJiraAdmin || projectContext?.data?.isProjectAdmin || false;
};
